export type ThemeType = 'PURPLE' | 'CRIMSON' | 'GOLD' | 'CYAN' | 'EMERALD' | 'ROSE';

export interface ThemeConfig {
  primary: string;
  hover: string;
  glow: string;
  border: string;
  borderInner: string;
}

export const THEME_MAP: Record<ThemeType, ThemeConfig> = {
  PURPLE: { primary: '#a855f7', hover: '#9333ea', glow: 'rgba(168,85,247,0.4)', border: '#3d2a4d', borderInner: '#6d4a8d' },
  CRIMSON: { primary: '#ef4444', hover: '#dc2626', glow: 'rgba(239,68,68,0.4)', border: '#4d1a1a', borderInner: '#8d4a4a' },
  GOLD: { primary: '#eab308', hover: '#ca8a04', glow: 'rgba(234,179,8,0.4)', border: '#4d451a', borderInner: '#8d4a8d' },
  CYAN: { primary: '#06b6d4', hover: '#0891b2', glow: 'rgba(6,182,212,0.4)', border: '#1a434d', borderInner: '#4a818d' },
  EMERALD: { primary: '#10b981', hover: '#059669', glow: 'rgba(16,185,129,0.4)', border: '#1a4d3a', borderInner: '#4a8d6d' },
  ROSE: { primary: '#f43f5e', hover: '#e11d48', glow: 'rgba(244,63,94,0.4)', border: '#4d1a2a', borderInner: '#8d4a5d' },
};
